import { useEffect } from 'react';
import { Joyride } from 'react-joyride';
import type { TourId } from '@sorrem/shared';
import { useTour } from './use-tour';

interface GuidedTourProps {
    tourId: TourId;
    /** Whether the moment for it has come (the page is shown, the run is playing); it starts once this holds. */
    isEnabled: boolean;
    /** Told when the tour comes on screen and when it leaves (the run holds its enemies meanwhile). */
    onRunningChange?: (isRunning: boolean) => void;
}

/**
 * A guided tour (#234): React Joyride, controlled by `useTour`, with the
 * first-time callout's look. Renders nothing once the account has finished
 * or skipped it.
 */
export function GuidedTour({ tourId, isEnabled, onRunningChange }: GuidedTourProps): JSX.Element | null {
    const { isRunning, joyrideProps } = useTour(tourId, isEnabled);

    useEffect(() => {
        onRunningChange?.(isRunning);
    }, [isRunning, onRunningChange]);

    return isRunning ? <Joyride {...joyrideProps} /> : null;
}
